import React from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from '@/models';
import CopyAssetUid from '@/components/icons/CopyAssetUid';
import weirenzheng from '@/assets/img/header/weirenzheng.png';
import copy from 'copy-to-clipboard';
import { message } from 'antd';
import cs from './index.module.scss';

export interface DropDownMenuItem {
  url: string;
  icon?: string;
  title: string;
  subTitle?: string;
  slot?: any;
}

interface Props extends React.ComponentProps<any> {
  data?: DropDownMenuItem[];
  onClick?: () => void;
}

const DropDownProfileMenu: React.FC<Props> = () => {
  const { push } = useHistory();
  const { account, ui } = useStore();
  const { t } = useTranslation();
  const { theme } = ui;

  const { isLogin, userName, accountInfo, userInfo, toSignOut, showUserName } = account;
  const { id } = userInfo;
  const list = [
    { title: t('account.profile.basic'), url: '/account/profile/basic' },

    { title: t('account.profile.verified'), url: '/account/profile/verified' },
    { title: t('account.profile.security1'), url: '/account/profile/security' },
    { title: t('account.profile.invite'), url: '/account/profile/invite' },
    // { title: t('account.profile.api'), url: '/account/profile/api' },
    { title: t('account.profile.logout'), onClick: toSignOut },
  ];
  const handleClick = (url: string, onClick?: Function) => {
    if (/^[(http)|(https)]/.test(url)) {
      window.location.href = url;
    } else {
      push(url);
    }
    if (onClick) {
      onClick();
    }
  };
  const copyUrl = () => {
    copy(id);

    message.success(t('success.copy'));
  };
  return (
    <div className={cs.container}>
      <div className={cs.userName}>{userName}</div>
      <div className={cs.userId}>
        <span>UID:{id}</span>
        <CopyAssetUid onClick={copyUrl} />
      </div>
      {/* <a
          className={cs.auth}
          onClick={() => {
            push('/account/profile/verified');
          }}
        >
          <img src={weirenzheng} alt="" />
          去认证
        </a> */}

      <div className={cs.line}></div>
      <div className={cs.list}>
        {list.map((item, index) => {
          const { title, url, onClick } = item;

          return (
            <a onClick={() => handleClick(url, onClick)} key={index} className={cs.dropdownItem}>
              {title}
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default observer(DropDownProfileMenu);
